import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import crossIcon from "../../../Assets/images/cross_icon.png";
import styles from "./ConfirmationPop.module.scss";
import { Formik, Form, useFormikContext } from "formik";
import * as Yup from "yup";
import { useCreateNoteMutation, useUpdateNoteMutation } from "store/services/V2/notes";
import { userFullName, successMessageToast } from "helpers/common";
import { useParams } from "react-router-dom";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { User } from "react-feather";
import LoadingButton from "components/shared/LoadingButton";
import { useLazyTherapistLookupQuery, useSubAdminLookupQuery, useTherapistLookupQuery } from "store/services/utility";
import { debounce } from "lodash";
import { useSelector } from "react-redux";
import { useAssignMultipleTherapistsMutation } from "store/services/clientCaseLoads";

const validationSchema = Yup.object({
  selectedTherapists: Yup.array()
    .min(1, "Please select at least one collaborator.")
    .required("Please select at least one collaborator."),
});

const AssignDisciplineModal = ({
  title,
  onCancel,
  confirmBtnText = "Save",
  show,
  setShow,
  caseLoadId,
  clientDetails,
  refetch
}) => {

  const [initialValues, setInitialValues] = useState({ selectedTherapists: [] })

  const [assignMultipleTherapists, { isLoading: assignMultipleTherapistsLoading }] = useAssignMultipleTherapistsMutation();
  const { data: therapistsListData, isFetching: therapistsListLoading } = useTherapistLookupQuery({ therapist_type: "veteran" });

  const formattedData = useMemo(() => {
    return (
      clientDetails?.clientCaseloads
        // Only the regular caseload belongs on the client detail page; MDT caseloads are managed on the MDT screens
        ?.filter(caseload => caseload?.case_type === "regular")
        ?.flatMap(caseload =>
          caseload?.clientCaseloadTherapist
            ?.flatMap(item =>
              item?.clientCaseloadMapping
                ?.filter(
                  x =>
                    x?.caseTherapist?.therapist_detail?.type === "veteran"
                )
                ?.map(caseloadMapping => ({
                  name: userFullName(caseloadMapping?.caseTherapist),
                  discipline: item?.caseDiscipline?.assign_term,
                  discipline_id: item?.discipline_id,
                  therapist_id: caseloadMapping?.therapist_id,
                  raw: { caseload, item, caseloadMapping }
                }))
            )
        ) || []
    );
  }, [clientDetails]);

  console.log('formattedData service data', formattedData)

  const [usersList, setUsersList] = useState([])
  const [searchText, setSearchText] = useState("");

  const filteredUsers = therapistsListData?.length > 0 ? therapistsListData?.filter((item) => {
    const fullName = userFullName(item)?.toLowerCase() || "";
    const email = item?.email?.toLowerCase() || "";
    const firstName = item?.first_name?.toLowerCase() || "";
    const lastName = item?.last_name?.toLowerCase() || "";

    return (
      fullName.includes(searchText) ||
      email.includes(searchText) ||
      firstName.includes(searchText) ||
      lastName.includes(searchText)
    );
  }) : [];

  const handleClose = () => {
    setShow(false);
    setSearchText("")
  };

  const handleSearch = (value) => {
    setSearchText(value.toLowerCase());
  };

  const handleSubmit = async (values, { setFieldValue }) => {
    const data = {
      assignee: values?.selectedTherapists?.map((item) => ({ therapist_id: item?.id, discipline_id: item?.discipline_id, case_id: caseLoadId }))
    }
    try {
      const response = await assignMultipleTherapists({ data }).unwrap()
      typeof refetch == "function" && refetch();
      successMessageToast(response?.message);
      setFieldValue("selectedTherapists", [])
      handleClose()
    } catch (error) {
      console.log('error', error)
    }
  };

  useEffect(() => {
    // if (therapists?.length) {
    //   setInitialValues((prev) => ({ ...prev, selectedTherapists: therapists?.length ? therapists?.map((item) => item?.therapist_id || item?.id) : [] }))
    // }
    // else {
    //   setInitialValues((prev) => ({ ...prev, selectedTherapists: [] }))
    // }
    if (formattedData?.length) {
      const data = formattedData?.map((item) => ({ id: item?.therapist_id, discipline_id: item?.discipline_id }))
      setInitialValues((prev) => ({ ...prev, selectedTherapists: data }))
    }
    else{
      setInitialValues((prev) => ({ ...prev, selectedTherapists: [] }) )
    }
  }, [formattedData])

  console.log('formattedData', formattedData)

  return (
    <Modal
      show={show}
      className={`${styles.ConfirmationPop} transparentModal modal-v2`}
      onHide={onCancel}
      backdrop="static"
      keyboard={false}
      centered
      size="md"
    >
      <Modal.Body className={`${styles.modalBody}`}>
        {(therapistsListLoading) && <LoadingOverlay />}
        <div className="text-center mx-auto">
          {/* Header */}
          <div
            className="section-title d-flex align-items-center justify-content-between"
            style={{ borderBottom: "1px solid #93278F" }}
          >
            <h3 className="mb-0 pb-0 section-title border-bottom-0" style={{ fontSize: "14px" }}>
              ASSIGN DISCIPLINE
            </h3>
            <img
              onClick={handleClose}
              width={16}
              height={16}
              src={crossIcon}
              alt="crossIcon"
              style={{ cursor: "pointer" }}
            />
          </div>

          {/* Formik Form */}
          <Formik
            initialValues={initialValues}
            // validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({ values, setFieldValue, errors, touched, isSubmitting }) => (
              <Form>
                <Row>
                  <Col lg="8">
                    <div className="d-flex w-100 align-items-center gap-3">
                      <input
                        onChange={(e) => handleSearch(e.target.value)}
                        className={` readonly-box h-auto search-input-filter-v2`}
                        placeholder="Search by name, email"
                      />
                    </div>
                    <div className="text-start mt-3">
                      <label htmlFor="" className="discharge-screen-label mt-0">
                        SELECT THERAPIST
                      </label>
                    </div>
                  </Col>
                </Row>

                {/* Table with Scrollbar */}
                <div
                  style={{
                    maxHeight: "400px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    scrollbarWidth: "thin",
                    scrollbarColor: "#b46c9f #f0f0f0",
                    // border: "1px solid #ccc",
                    // borderRadius: "8px",
                  }}
                >
                  <table className="w-100">
                    <thead>
                      <tr>
                        <th
                          style={{
                            // padding: "12px 10px",
                            // borderBottom: "2px solid #8F8F8F",
                            borderBottom: "0",
                            textAlign: "left",
                          }}
                        >
                          <div className="d-flex align-items-center gap-3">
                            <div></div>
                            {/* <input
                              type="checkbox"
                              style={{
                                accentColor: "#b46c9f",
                                height: 20,
                                width: 20,
                              }}
                              checked={allIds.every((id) => values.selectedTherapists.includes(id))}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setFieldValue("selectedTherapists", allIds);
                                } else {
                                  setFieldValue("selectedTherapists", []);
                                }
                              }}
                            /> */}
                            {/* <span>Users</span> */}
                          </div>
                        </th>

                        <th
                          style={{
                            // padding: "12px 10px",
                            // borderBottom: "2px solid #8F8F8F",
                            borderBottom: "0",
                            textAlign: "center",
                          }}
                        >
                          {/* Discipline */}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredUsers?.map((item, index) => {
                        const isChecked = values?.selectedTherapists?.some(
                          (sel) => sel?.id == item?.id
                        );
                        return (
                          <tr key={index}>
                            <td
                              style={{
                                padding: "12px 10px",
                                borderBottom: "1px solid #8F8F8F",
                                borderRadius: "0px"
                              }}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <input
                                  type="checkbox"
                                  disabled={values?.selectedTherapists?.find((x) => x?.discipline_id == item?.therapist_detail?.therapist_discipline?.id && x?.id != item?.id) || formattedData?.some((i) => i?.therapist_id == item?.id)}
                                  style={{
                                    accentColor: "#b46c9f",
                                    height: 24,
                                    width: 24,
                                    marginTop: "-3px",
                                  }}
                                  checked={isChecked}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setFieldValue("selectedTherapists", [
                                        ...values.selectedTherapists,
                                        { id: item?.id, discipline_id: item?.therapist_detail?.therapist_discipline?.id },
                                      ]);
                                    } else {
                                      setFieldValue(
                                        "selectedTherapists",
                                        values.selectedTherapists.filter(
                                          (sel) => sel?.id !== item?.id
                                        )
                                      );
                                    }
                                  }}
                                />
                                {
                                  item?.therapist_detail?.profile_picture ?
                                    <img
                                      // src={item?.therapist_detail?.profile_picture}
                                      alt=""
                                      className="img-fluid object-fit-cover rounded-circle border border-white"
                                      style={{ height: 30, width: 30 }}
                                    /> :
                                    <User size={30} />
                                }
                                <span className="proxima text-start" style={{ color: "#000" }}>{`${userFullName(item)}`}</span>
                              </div>
                            </td>
                            <td
                              className="text-center"
                              style={{
                                padding: "12px 10px",
                                borderBottom: "1px solid #8F8F8F",
                                borderRadius: "0px",
                                width: "100px",
                              }}
                            >
                              <span className={`discipline-${item?.therapist_detail?.therapist_discipline?.assign_term}-capsule-bcg`} style={{ padding: "7px 10px", marginRight: "3px", borderRadius: "8px" }}>{item?.therapist_detail?.therapist_discipline?.assign_term}</span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {touched.selectedTherapists && errors.selectedTherapists && (
                  <div className="text-danger mt-2" style={{ fontSize: "13px" }}>
                    {errors.selectedTherapists}
                  </div>
                )}

                {/* Buttons */}
                <div className="d-flex justify-content-end mt-4 gap-2">
                  <button
                    onClick={handleClose}
                    disabled={isSubmitting}
                    className='blue-discharge-screen-btn-border'
                  >
                    Cancel
                  </button>

                  <LoadingButton
                    type="submit"
                    isLoading={isSubmitting || assignMultipleTherapistsLoading}
                    className="blue-discharge-screen-btn"
                  >
                    {confirmBtnText}
                  </LoadingButton>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AssignDisciplineModal;
